<template>
	<BaseCmsPage v-slot="{page}">
		<ClientOnly>
			<h1>{{ page?.seo_h1 }}</h1>
			<p>Uspješno ste se odjavili</p>
		</ClientOnly>
	</BaseCmsPage>
</template>
